import {
    Modal,
    Menu,
    ToolbarIcon,
    InfoPanel,
} from '@instinet-analytics/semantic-ui-components';
import React, { useState } from 'react';
import { doNothing } from 'utils/general';
import { useSelectUserHasAuthority } from 'login/store/selectors';

import './EstimatedTradeCostDebugModal.scss';

import { useEstimatedTradeCostData } from '../../hooks';
import { useEstimatedTradeCostWidgetConfigSlice } from '../../store/configslice';
import {
    initialEstimatedTradeCostComponentState,
    useEstimatedTradeCostWidgetComponentSlice,
} from '../../store/componentSlice';
import classNames from 'classnames';
import JsonPanel from 'utils/components/JsonPanel/JsonPanel';

export function EstimatedTradeCostDebugModal() {
    const enableSupport = useSelectUserHasAuthority(
        'indigo.enableIndigo2Support'
    );

    if (!enableSupport) {
        return <></>;
    }

    return (
        <div className="EstimatedTradeCostDebugModal">
            <Modal
                className="EstimatedTradeCostDebugModal_Modal"
                trigger={<ToolbarIcon name="bug" tooltip={'Debug'} />}
                headerText="Pre-Trade Cost Debug"
                onSave={doNothing}
                saveText="Close"
            >
                <EstimatedTradeCostDebugModalBody />
            </Modal>
        </div>
    );
}

function EstimatedTradeCostDebugModalBody() {
    const [view, setView] = useState('request');

    return (
        <div className="EstimatedTradeCostDebugModalBody">
            <Menu pointing vertical>
                <MenuItem
                    view={'request'}
                    text={'Request'}
                    onChangeView={setView}
                    activeView={view}
                />
                <MenuItem
                    view={'config'}
                    text={'Config'}
                    onChangeView={setView}
                    activeView={view}
                />
                <MenuItem
                    view={'component'}
                    text={'Component'}
                    onChangeView={setView}
                    activeView={view}
                />
            </Menu>
            <div className="EstimatedTradeCostDebugModalBodyContent">
                <EstimatedTradeCostDebugModalBodyContent view={view} />
            </div>
        </div>
    );
}

function MenuItem(props: {
    activeView: string;
    view: string;
    text: string;
    className?: string;
    onChangeView: (nextView: string) => void;
}) {
    const { activeView, view, onChangeView, text, className } = props;
    const cssClasses = classNames('menu-' + view, className);
    return (
        <Menu.Item
            active={activeView === view}
            onClick={() => onChangeView(view)}
            className={cssClasses}
        >
            {text}
        </Menu.Item>
    );
}

function EstimatedTradeCostDebugModalBodyContent({ view }: { view: string }) {
    const { config } = useEstimatedTradeCostWidgetConfigSlice();
    const { component } = useEstimatedTradeCostWidgetComponentSlice();
    const data = useEstimatedTradeCostData();

    switch (view) {
        case 'request':
            return (
                <NullableJsonPanel data={data} desc={'No request data found'} />
            );
        case 'config':
            return (
                <NullableJsonPanel
                    data={config}
                    desc={'No config state saved'}
                />
            );
        case 'component':
            return (
                <NullableJsonPanel
                    data={
                        component === initialEstimatedTradeCostComponentState
                            ? undefined
                            : component
                    }
                    desc={'No component state saved'}
                />
            );
    }
    return <div>View: {view}</div>;
}

function NullableJsonPanel({ data, desc }: { data: unknown; desc: string }) {
    if (!data) {
        return <InfoPanel message={desc} />;
    }
    return <JsonPanel data={data} />;
}
